import styledComp from 'styled-components';
import {
  FormControl, Select, InputLabel,
} from '@mui/material';
import { Styling } from '../../../../constants';
import { ActionContainer, DialogActionsOverride } from '../../../Shared/styles/dialog';

export const ProgressContainer = styledComp.div`
  height: 4px;
`;

export const ControlContainer = styledComp(FormControl)`
  margin: ${Styling.DEFAULT_SPACING}px auto ${Styling.DEFAULT_SPACING_HALVED}px auto !important;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
  width: 250px;
`;

export const SelectContainer = styledComp(Select)`
  width: 160px;
`;

export const FormRow = styledComp.div`
  margin: ${Styling.DEFAULT_SPACING}px auto ${Styling.DEFAULT_SPACING_HALVED}px auto !important;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  justify-items: center;
`;

export const FormLabel = styledComp.span`
  display: inline-flex;
  align-items: center;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const InputContainer = styledComp.div`
  
`;

export const StyledDialogActionsOverride = styledComp(DialogActionsOverride)`
  margin-top: 30px;
`;
